import { Option } from '../../option.class';

declare module '../../option.class' {
  interface Option {
  }
}
Option.prototype.onComposeInit = function(type: string) {
  // ... another exercise for the reader
};
